import { Power1, Power2, TweenMax } from 'gsap';
import $ from 'jquery';
import ImageDelayLoadClass from '../load/ImageDelayLoadClass';
import SectionBaseClass from '../base/SectionBaseClass';
import TouchEventClass from '../event/TouchEventClass';
import Util from '../util/Util';

/**
 * スライドクラス
 *
 * @example
 * <div class="slide_wrap">
 * <div class="slide_mask">
 * <div class="slide_inner">
 * <ul>
 * <li><img src="" alt=""></li>
 * <li><img src="" alt=""></li>
 * <li><img src="" alt=""></li>
 * <li><img src="" alt=""></li>
 * <li><img src="" alt=""></li>
 * <li><img src="" alt=""></li>
 * </ul>
 * </div><!-- /slide_inner -->
 * </div><!-- /slide_mask -->
 * <div class="current"></div>
 *
 * <a href="" class="arrow prev"></a>
 * <a href="" class="arrow next"></a>
 * </div><!-- /slide_wrap -->
 */
export default class ImageSlideClass extends SectionBaseClass {
  constructor(_parent, _params = { itemWrapSelector: 'ul', itemSelector: 'li' }) {
    super(_parent);

    this.name = 'ImageSlideClass';

    this.EVENT_ACTIVE_CHANGE = 'eventActiveChange';
    this.EVENT_CLICK = 'eventClick';
    this.CL_ACTIVE = 'isActive';
    this.CL_DISABLE = 'isDisable';
    this.INT_TIMER_INTERVAL = 5000;

    this.BOX_LENGTH = 0;
    this.BOX_WIDTH = 0;
    this.$parent = _parent;
    this.params = _params;
    this.$target;
    this.$imgwrap;
    this.$wrap;
    this.$items;
    this.nowNum;
    this.activeNowNum = -1;
    this.$mask;
    this.isMoveAnimation = false;
    this.nowPos = 0;
    this.touchEvent = new TouchEventClass();
    this.isTouchClick = false;
    this.slideItemNum = 1;

    this.delayItems;
    this.$currentNav;

    this.timerId;
    this.isTimer = false;
    this.isLoop = false;
    this.isAutoStart = true;
    this.isBlockLoop = true;

    this.isSlide = true;
    this.isClickBlock = false;

    this.onClickThumListener = this.onClick_thum.bind(this);
    this.onClickCurrentNavListener = this.onClick_currentNav.bind(this);
    this.onClickArrowLeftListener = this.onClick_arrowLeft.bind(this);
    this.onClickArrowRightListener = this.onClick_arrowRight.bind(this);
    this.onTouchStartListener = this.onTouchStart.bind(this);
    this.onTouchMoveListener = this.onTouchMove.bind(this);
    this.onTouchEndListener = this.onTouchEnd.bind(this);
  }


  onCreate() {
    super.onCreate();
    this.$wrap = $('.slide_wrap', this.$parent);
    this.$mask = $('.slide_mask', this.$parent);
    this.$target = $('.slide_inner', this.$parent);
    this.$imgwrap = $(this.params.itemWrapSelector, this.$target);
    this.$currentNav = $('.current', this.$parent);
    this.$arrowLeft = $('.arrow.prev', this.$parent);
    this.$arrowRight = $('.arrow.next', this.$parent);

    this.isModalIn = (this.$parent.closest('.modal').length > 0);

    this.nowPos = 0;
    this.nowNum = 0;
    this.BOX_LENGTH = $(this.params.itemSelector, this.$imgwrap).length;

    if (this.BOX_LENGTH <= this.slideItemNum) {
      this.isSlide = false;
      this.$items = $(this.params.itemSelector, this.$imgwrap);
      this.addDelayLoad();
      if (this.$arrowLeft.length > 0) {
        this.$arrowLeft.hide();
      }
      if (this.$arrowRight.length > 0) {
        this.$arrowRight.hide();
      }
      this.$items.addClass(this.CL_ACTIVE);
      this.isTouchClick = true;
      $('a', this.$items).on('click', this.onClickThumListener);
      return;
    }

    if (this.isBlockLoop) {
      let imgHtml = this.$imgwrap.html();
      this.$imgwrap.append(imgHtml);
      this.$imgwrap.append(imgHtml);

      if (this.BOX_LENGTH === 2) {
        this.$imgwrap.append(imgHtml);
        this.$imgwrap.append(imgHtml);
      }
    }

    this.$items = $(this.params.itemSelector, this.$imgwrap);

    this.maxNum = this.$items.length - this.slideItemNum;

    this.addDelayLoad();


    if (this.$arrowLeft.length > 0) {
      this.$arrowLeft.on('click', this.onClickArrowLeftListener);
    }

    if (this.$arrowRight.length > 0) {
      this.$arrowRight.on('click', this.onClickArrowRightListener);
    }

    if (this.$currentNav.length > 0) {
      let currentHtml = '<ul>';
      for (let i = 0; i < this.BOX_LENGTH; i++) {
        currentHtml += '<li><a href=""></a></li>';
      }
      currentHtml += '</ul>';
      this.$currentNav.html(currentHtml);
      $('a', this.$currentNav).on('click', this.onClickCurrentNavListener);
    }


    $('a', this.$items).on('click', this.onClickThumListener);

    this.onResize(Util.getWindowSize());
    this.moveCallback(this.nowNum);
    this.activeChange(this.nowNum);

    this.touchEvent.onCreate(this.$target, true);
    this.touchEvent.bind(this.touchEvent.EVENT_TOUCH_START, this.onTouchStartListener);
    this.touchEvent.bind(this.touchEvent.EVENT_TOUCH_MOVE, this.onTouchMoveListener);
    this.touchEvent.bind(this.touchEvent.EVENT_TOUCH_END, this.onTouchEndListener);
    this.touchEvent.addEvent();

    this.$countText = $('.num', this.$parent);
    this.setCountText(0);
  }

  onLoad() {
    super.onLoad();
    for (let k in this.delayItems) { this.delayItems[k].onLoad(); }
  }

  onResize(_size) {
    if (!this.target || (Util.isSpModalOpen && !this.isModalIn) || this.target.is(':hidden')) { return; }

    const size = { w: this.$parent.outerWidth(true), h: this.$parent.outerHeight(true) };

    let offset = $.extend({}, this.$wrap.offset());
    let height = this.$wrap.outerHeight(true);
    let top = 0; let bottom = height;
    if (height < size.h * 0.5) {
      top = Math.floor(offset.top + height - _size.h);
      bottom = Math.floor(offset.top);
    } else {
      top = Math.floor(offset.top) - _size.h * 0.8;
      bottom = Math.floor(Math.floor(offset.top) + this.$wrap.outerHeight(true) * 0.8);
    }

    this.offset = { top: top, bottom: bottom };

    this.htmlLast = $('html').outerHeight(true) - _size.h - 10;

    for (let k in this.delayItems) { this.delayItems[k].onResize(_size); }

    if (!this.isSlide) { return; }

    this.BOX_WIDTH = this.$items.outerWidth(true);
    const boxLoopLength = (this.isBlockLoop) ? 3 : 1;
    this.BLOCK_WIDHT = this.BOX_WIDTH * this.BOX_LENGTH * boxLoopLength;

    const innerWidth = this.$wrap.width();
    const innerCount = Math.floor(innerWidth / this.BOX_WIDTH);
    const innerDiff = innerWidth - this.BOX_WIDTH * innerCount;

    this.LIMIT_WIDTH = (this.BLOCK_WIDHT - this.$mask.outerWidth(true) + innerDiff) * -1;
    this.$imgwrap.css({ width: this.BLOCK_WIDHT });
    if (!this.isMoveAnimation) {
      TweenMax.set(this.$imgwrap, { x: this.getLeft(this.nowNum) });
    }
  }

  onChangeBreakPoint() {
    super.onChangeBreakPoint();
    for (let k in this.delayItems) { this.delayItems[k].onChangeBreakPoint(); }
  }

  onScroll(st) {
    super.onScroll(st);
    for (let k in this.delayItems) { this.delayItems[k].onScroll(st); }
  }

  onRemove() {
    this.touchEvent.removeEvent();
    $('a', this.$items).off('click', this.onClickThumListener);

    if (this.$arrowLeft.length > 0) {
      this.$arrowLeft.off('click', this.onClickArrowLeftListener);
      this.$arrowLeft.removeClass(this.CL_DISABLE);
      this.$arrowLeft.show();
    }

    if (this.$arrowRight.length > 0) {
      this.$arrowRight.off('click', this.onClickArrowRightListener);
      this.$arrowRight.removeClass(this.CL_DISABLE);
      this.$arrowRight.show();
    }
  }

  onStart() {
    if (!this.isSlide || !this.isAutoStart) { return; }
    // console.log(this.name,"onStart");
    this.isLoop = true;
    this.onStartTimer();
  }

  onStop() {
    if (!this.isSlide || !this.isAutoStart) { return; }
    // console.log(this.name,"onStop");
    this.isLoop = false;
    this.onStopTimer();
  }

  onStartTimer() {
    if (this.isTimer || !this.isLoop || !this.isAutoStart) { return; }
    this.isTimer = true;
    const self = this;
    this.timerId = setTimeout(() => {
      self.onStopTimer();
      self.next();
    }, this.INT_TIMER_INTERVAL);
  }

  onStopTimer() {
    if (!this.isTimer) { return; }
    this.isTimer = false;
    clearTimeout(this.timerId);
  }

  onClick_thum(e) {
    if (this.isTouchClick && !this.isClickBlock) { return; }
    e.preventDefault();
    if (this.isTouchClick) {
      this.jq.trigger(this.EVENT_CLICK, { event: e });
    }
  }

  onClick_currentNav(e) {
    e.preventDefault();
    let index = $('li', this.$currentNav).index($(e.currentTarget).closest('li'));
    if (index > this.maxNum) { index = this.maxNum; }
    this.move(index);
  }

  onClick_arrowLeft(e) {
    e.preventDefault();
    this.prev();
  }

  onClick_arrowRight(e) {
    e.preventDefault();
    this.next();
  }

  onTouchStart(e, d) {
    this.onStopTimer();
    TweenMax.killTweensOf(this.$imgwrap);
    this.isTouchClick = false;
    this.isMoveAnimation = false;
    this.nowPos = parseFloat((Util.getTransfromValue(this.$imgwrap.css('transform')))['transform-x']);

    if (!this.isBlockLoop) { return; }
    if (this.nowPos <= this.BOX_WIDTH * this.BOX_LENGTH * 2 * -1) {
      this.nowPos += this.BOX_WIDTH * this.BOX_LENGTH;
      this.nowNum -= this.BOX_LENGTH;
    } else if (this.nowPos > this.BOX_WIDTH * this.BOX_LENGTH * -1) {
      this.nowPos -= this.BOX_WIDTH * this.BOX_LENGTH;
      this.nowNum += this.BOX_LENGTH;
    }
  }

  onTouchMove(e, d) {
    let touchVar = d.data;
    let event = d.event;
    let direction = Util.getDirection(Util.getAngle({ x: touchVar.startX, y: touchVar.startY }, { x: touchVar.endX, y: touchVar.endY }));

    if (Math.abs(touchVar.startY - touchVar.endY) > 150 || direction === 'up' || direction === 'down') {
      //
    } else {
      event.preventDefault();
      let x = touchVar.startX - touchVar.endX;
      let moveX = this.nowPos - x;
      if (!this.isBlockLoop) {
        // console.log( touchVar.startX,touchVar.endX,moveX,x);
        if (moveX > 0) {
          moveX = moveX * 0.3;
        } else if (moveX < this.LIMIT_WIDTH) {
          moveX = this.LIMIT_WIDTH + (moveX - this.LIMIT_WIDTH) * 0.3;
        }
      }
      TweenMax.set(this.$imgwrap, { x: moveX });
      touchVar.diff = touchVar.startX - touchVar.endX;
    }
  }

  onTouchEnd(e, d) {
    let touchVar = d.data;
    let event = d.event;

    // console.log(this.name,"onTouchEnd",this.isTouchClick,touchVar);
    if (touchVar.diff !== null) {
      event.preventDefault();
      // console.log(this.name,"onTouchEnd",this.isTouchClick,touchVar.diff);

      if (this.slideItemNum === 1 && touchVar.diff > 50) {
        this.next();
      } else if (this.slideItemNum === 1 && touchVar.diff < -50) {
        this.prev();
      } else if (Math.abs(touchVar.diff) > 50 && this.slideItemNum > 1) {
        const nowX = parseFloat((Util.getTransfromValue(this.$imgwrap.css('transform')))['transform-x']);
        let n = this.getXtoN(nowX);
        if (n > this.maxNum) { n = this.maxNum; }
        this.move(n);
      } else {
        if (Math.abs(touchVar.diff) <= 1) { this.isTouchClick = true; }
        this.isMoveAnimation = true;
        TweenMax.to(this.$imgwrap, 0.5, {
          x: this.getLeft(this.nowNum), ease: Power2.easeOut, onComplete: () => {
            this.wrapPositionSet(this.nowNum);
            this.isMoveAnimation = false;
            this.onStartTimer();
          },
        });
      }
    } else {
      this.isTouchClick = true;
      this.onStartTimer();
    }
  }

  next() {
    if (this.isMoveAnimation) { return; }
    let n = this.nowNum + this.slideItemNum;
    if (!this.isBlockLoop && n > this.maxNum) { n = this.maxNum; }
    this.move(n);
  }

  prev() {
    if (this.isMoveAnimation) { return; }
    let n = this.nowNum - this.slideItemNum;
    if (!this.isBlockLoop && n < 0) { n = 0; }
    this.move(n);
  }

  move(n) {
    if (this.isMoveAnimation) { return; }
    this.isMoveAnimation = true;

    const self = this;
    this.activeChange(n);
    let x = this.getLeft(n);
    this.nowNum = n;

    let index = this.getNum(n);
    this.jq.trigger(this.EVENT_ACTIVE_CHANGE, { index: index, isAnim: true });
    this.setCountText(index);

    this.arrowChange(n);
    TweenMax.to(this.$imgwrap, 0.5, {
      x: x, ease: Power1.easeOut, onComplete: () => {
        self.moveCallback(n);
      },
    });
  }

  justMove(n) {
    this.activeChange(n);
    let x = this.getLeft(n);
    this.nowNum = n;

    let index = this.getNum(n);
    this.jq.trigger(this.EVENT_ACTIVE_CHANGE, { index: index, isAnim: false });
    this.setCountText(index);

    this.arrowChange(n);
    TweenMax.set(this.$imgwrap, { x: x });
    this.moveCallback(n);
  }

  moveCallback(n) {
    n = this.getNum(n);
    this.activeChange(n);
    this.wrapPositionSet(n);
    this.nowNum = n;
    this.isMoveAnimation = false;
    this.onStartTimer();
    this.arrowChange(n);
    $(window).trigger('resize');
  }

  wrapPositionSet(n) {
    let x = this.getLeft(n);
    TweenMax.set(this.$imgwrap, { x: x });
    this.nowPos = x;
  }

  getLeft(n) {
    let base = (this.isBlockLoop) ? this.BOX_WIDTH * this.BOX_LENGTH : 0;
    return (base + this.BOX_WIDTH * n) * -1;
  }

  getNum(_n) {
    if (_n < 0) { _n = this.BOX_LENGTH + _n; }
    return _n % this.BOX_LENGTH;
  }

  getXtoN(_x) {
    let x = Math.abs(_x);
    if (this.isBlockLoop) { x -= this.BOX_WIDTH * this.BOX_LENGTH; }
    return Math.round(x / this.BOX_WIDTH);
  }

  setIsClickBlock(_b) {
    this.isClickBlock = _b;
  }

  addDelayLoad() {
    const self = this;
    this.delayItems = [];
    $('img', this.$items).each((index, element) => {
      self.delayItems.push(new ImageDelayLoadClass($(element), false, true));
    });
    for (let k in this.delayItems) {
      this.delayItems[k].onCreate();
      this.delayItems[k].isImageLoadEnd = true;
      this.delayItems[k].onResize(Util.getWindowSize());
    }
  }

  activeChange(_n) {
    let i = this.getNum(_n);
    if (this.$currentNav.length > 0) {
      $('li', this.$currentNav).removeClass(this.CL_ACTIVE).slice(i, i + this.slideItemNum).addClass(this.CL_ACTIVE);
    }
    const itemNum = (this.isBlockLoop) ? _n + this.BOX_LENGTH : _n;
    this.$items.removeClass(this.CL_ACTIVE).slice(itemNum, itemNum + this.slideItemNum).addClass(this.CL_ACTIVE);
  }

  arrowChange(_n) {
    if (this.isBlockLoop) { return; }

    if (this.$arrowLeft.length > 0) {
      if (_n <= 0) {
        this.$arrowLeft.addClass(this.CL_DISABLE);
      } else {
        this.$arrowLeft.removeClass(this.CL_DISABLE);
      }
    }

    if (this.$arrowRight.length > 0) {
      if (_n >= this.maxNum) {
        this.$arrowRight.addClass(this.CL_DISABLE);
      } else {
        this.$arrowRight.removeClass(this.CL_DISABLE);
      }
    }
  }

  setCountText(_num) {
    if (_num === 0 && this.BOX_LENGTH === 0 ){
      this.$countText.text((_num ) + '/' + this.BOX_LENGTH);
    } else {
      this.$countText.text((_num + 1) + '/' + this.BOX_LENGTH);
    }
  }
}
